( function() {
    "use strict";

    angular
        .module('ccsTrApp')
        .controller( 'LotSplitModalController', LotSplitModalController );

    LotSplitModalController.$inject = ['$scope', '$uibModalInstance', '$q', 'Lot', 'Contract', 'myLot', 'ToastrService',
                                        'LotCustomService', 'ContractCustomService', 'ShipmentCustomService'];

    function LotSplitModalController( $scope, $uibModalInstance, $q, Lot, Contract, myLot, ToastrService,
                                    LotCustomService, ContractCustomService, ShipmentCustomService ) {

        var vm = this;
        vm.originLot;

        vm.siList = [];

        vm.myAction = "";
        if( myLot.constructor === Array ) {
            vm.originLot = myLot[0];
            vm.myAction = "normal";
            vm.splitLot = buildSplitLot();
            fetchPurchSIs();
        } else {
            vm.originLot = myLot;
            vm.myAction = "other";
            checkPurchaseContract();
        }

        vm.splitMethods = ['AVG Weights','Manual Entry'];
        vm.splitMethod = vm.splitMethods[0];

        function checkPurchaseContract() {
            if( vm.originLot.purchase === undefined ) {
                applyMissingLazyStuff();
            } else {
                vm.splitLot = buildSplitLot();
                fetchPurchSIs();
            }
        }

        vm.splitAllocSiRequired = false;

        vm.myLots = [];
        vm.originQty = 0;
        //split method -- avg weights
        vm.originWtGross = 0;
        vm.originWtTare = 0;
        vm.originQty = 0;
        vm.originKgs = 0;
        vm.originKgsGross = 0;
        vm.originKgsTare = 0;
        vm.originLbs = 0;
        vm.originLbsGross = 0;
        vm.originLbsTare = 0;
        vm.originMts = 0;
        vm.originMtsGross = 0;
        vm.originMtsTare = 0;
        //split method -- manual entry
        vm.originWtManual = 0;
        vm.originWtGrossManual = 0;
        vm.originWtTareManual = 0;
        vm.originKgsManual = 0;
        vm.originKgsGrossManual = 0;
        vm.originKgsTareManual = 0;
        vm.originLbsManual = 0;
        vm.originLbsGrossManual = 0;
        vm.originLbsTareManual = 0;
        vm.originMtsManual = 0;
        vm.originMtsGrossManual = 0;
        vm.originMtsTareManual = 0;
        //split weights
        vm.splitWt = 0;
        vm.splitWtGross = 0;
        vm.splitWtTare = 0;
        vm.splitWtManual = 0;
        vm.splitWtGrossManual = 0;
        vm.splitWtTareManual = 0;
        vm.wtAvg = vm.originLot.actualWtAvg;
        vm.wtGrossAvg = vm.originLot.actualWtGrossAvg;
        vm.wtTareAvg = vm.originLot.actualWtTareAvg;

        vm.clear = clear;
        vm.save = save;
        vm.calculate = calculate;
        vm.validateSi = validateSi;
        vm.activateSplitMethod = activateSplitMethod;
        vm.fetchPurchSIs = fetchPurchSIs;
        vm.clearShipmentSelection = clearShipmentSelection;

        function activateSplitMethod( option ) {
            vm.splitMethod = option;
        }

        function fetchPurchSIs() {
            vm.siList.length = 0;
            ShipmentCustomService.returnMinifiedShipmentsByPurchaseAndSaleContract( vm.splitLot.purchase.id, 0 ).then( function( data ) {
                vm.siList = data.data;
                if(vm.originLot.purchSi !== null && vm.originLot.purchSi !== undefined) {
                    var exists = vm.siList.some(function(val) {
                        return val.id === vm.originLot.purchSi.id;
                    });
                    if(!exists) {
                        vm.siList.push(vm.originLot.purchSi);
                    }
                }
                if( vm.siList.length > 0 ) {
                    // ToastrService.success( "Grabbed Shipment List", "Success!" );
                } else {
                    ToastrService.warning( "Shipment List is blank", "Warning" );
                }
            }, function( error ) {
                if( error.status !== 404 ) {
                    ToastrService.error( "Cannot Get Shipment List: " + error.statusText, "Error" );
                }
                console.log( error.statusText );
            });
            if( vm.originLot.allocSale !== null && vm.originLot.allocSale !== undefined ) {
                vm.originLot.allocSi = vm.originLot.purchSi;
            }
        }

        function clearShipmentSelection() {
            vm.splitLot.purchSi = null;
            vm.splitLot.allocSale = null;
            vm.splitLot.allocSi = null;
        }

        applyOriginWeightQty();

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            switch (vm.splitMethod) {
            case 'AVG Weights':
                setOriginLotWeightsQty();
                resolveWtDisplay(vm.originWt, vm.splitWt, vm.originLot.purchWtType);
                break;
            case 'Manual Entry':
                setOriginLotWeightsQtyManual();
                setSplitLotWeightsManual();
                resolveWtDisplay(vm.originWtManual, vm.splitWtManual, vm.originLot.purchWtType);
                break;
            }
            vm.myLots.push(vm.originLot);
            vm.myLots.push(vm.splitLot);
            LotCustomService.splitLots(vm.myLots).then(function (response) {
                vm.isSaving = false;
                var data = response.data;
                switch (vm.myAction) {
                case 'other':
                    if (vm.splitLot.purchSi !== undefined && vm.splitLot.purchSi !== null) {
                        if (vm.originLot.purchSi && vm.splitLot.purchSi && vm.originLot.purchSi.id === vm.splitLot.purchSi.id) {
                            $uibModalInstance.close(data);
                        } else {
                            $uibModalInstance.close(data[0]);
                        }
                    } else {
                        $uibModalInstance.close(data[0]);
                    }
                    break;
                default:
                    ToastrService.success("Split Lot Success", "Success!");
                    $uibModalInstance.close(response);
                    break;
                }
            }, function (error) {
                vm.isSaving = false;
                if (error.status !== 404) {
                    ToastrService.error("Something went wrong: " + error.statusText, "Error!");
                }
                console.log(error.statusText);
            });
        }

        function buildSplitLot() {
            var splitLot = angular.copy( vm.originLot );
            splitLot.id = null;
            splitLot.lotStatus = "AVAILABLE";
            splitLot.purchSi = null;
            splitLot.allocSale = null;
            splitLot.allocSi = null;
            splitLot.allocInv = null;
            splitLot.salePriceUnit = null;
            splitLot.saleWtType = null;
            splitLot.salePrice = 0;
            splitLot.saleFinalPrice = 0;
            splitLot.saleValue = 0;
            splitLot.qtyBales = 0;
            splitLot.lotWeightKgs = 0;
            splitLot.lotWeightLbs = 0;
            splitLot.lotWeightMts = 0;
            //purchase weights
            splitLot.purchGrossKgs = 0;
            splitLot.purchNetKgs = 0;
            splitLot.purchTareKgs = 0;
            splitLot.purchGrossLbs = 0;
            splitLot.purchNetLbs = 0;
            splitLot.purchTareLbs = 0;
            splitLot.purchGrossMTs = 0;
            splitLot.purchNetMTs  = 0;
            splitLot.purchTareMTs  = 0;
            //purchase landed weights
            splitLot.purchLandedGrossKgs = 0;
            splitLot.purchLandedNetKgs = 0;
            splitLot.purchLandedTareKgs = 0;
            splitLot.purchLandedGrossLbs = 0;
            splitLot.purchLandedNetLbs = 0;
            splitLot.purchLandedTareLbs = 0;
            splitLot.purchLandedGrossMTs = 0;
            splitLot.purchLandedNetMTs = 0;
            splitLot.purchLandedTareMTs = 0;
            //sale weights
            splitLot.saleGrossKgs = 0;
            splitLot.saleNetKgs = 0;
            splitLot.saleTareKgs = 0;
            splitLot.saleGrossLbs = 0;
            splitLot.saleNetLbs = 0;
            splitLot.saleTareLbs = 0;
            splitLot.saleGrossMTs = 0;
            splitLot.saleNetMTs = 0;
            splitLot.saleTareMTs = 0;
            //sale landed weights
            splitLot.saleLandedGrossKgs = 0;
            splitLot.saleLandedNetKgs = 0;
            splitLot.saleLandedTareKgs = 0;
            splitLot.saleLandedGrossLbs = 0;
            splitLot.saleLandedNetLbs = 0;
            splitLot.saleLandedTareLbs = 0;
            splitLot.saleLandedGrossMTs = 0;
            splitLot.saleLandedNetMTs = 0;
            splitLot.saleLandedTareMTs = 0;
            //inter weights
            splitLot.interGrossKgs = 0;
            splitLot.interNetKgs = 0;
            splitLot.interTareKgs = 0;
            splitLot.interGrossLbs = 0;
            splitLot.interNetLbs = 0;
            splitLot.interTareLbs = 0;
            splitLot.interGrossMTs = 0;
            splitLot.interNetMTs = 0;
            splitLot.interTareMTs = 0;
            //inter landed weights
            splitLot.interLandedGrossKgs = 0;
            splitLot.interLandedNetKgs = 0;
            splitLot.interLandedTareKgs = 0;
            splitLot.interLandedGrossLbs = 0;
            splitLot.interLandedNetLbs = 0;
            splitLot.interLandedTareLbs = 0;
            splitLot.interLandedGrossMTs = 0;
            splitLot.interLandedNetMTs = 0;
            splitLot.interLandedTareMTs = 0;
            return splitLot;
        }

        function applyMissingLazyStuff() {
            vm.splitLot = buildSplitLot();
            var promise = [];
            promise.push(
                ContractCustomService.returnPurchaseContractByLot( vm.originLot.id ).then( function( data ) {
                    vm.originLot.purchase = data.data;
                    vm.splitLot.purchase = data.data;
                }, function( error ) {
                    if( error.status !== 404 ) {
                        ToastrService.error( "Something went wrong while fetching Purchase Contract: " + error.statusText, "Error" );
                    }
                    console.log( error.statusText );
                })
            );
            promise.push(
                ContractCustomService.returnSaleContractByLot( vm.originLot.id ).then( function( data ) {
                    vm.originLot.allocSale = data.data;
                }, function( error ) {
                    if( error.status !== 404 ) {
                        ToastrService.error( "Something went wrong while fetching Sale Contract: " + error.statusText, "Error" );
                    }
                    console.log( error.statusText );
                })
            );
            promise.push(
                ShipmentCustomService.returnPurchShipmentByLot( vm.originLot.id ).then( function( data ) {
                    vm.originLot.purchSi = data.data;
                }, function( error ) {
                    if( error.status !== 404 ) {
                        ToastrService.error( "Something went wrong while fetching Purch Shipping Instruction: " + error.statusText, "Error" );
                    }
                    console.log( error.statusText );
                })
            );
            $q.all( promise ).then( function () {
                fetchPurchSIs();
            });
        }

        function applyOriginWeightQty() {
            vm.originQty = vm.originLot.qtyBales;
            vm.originKgs = vm.originLot.lotWeightKgs;
            vm.originLbs = vm.originLot.lotWeightLbs;
            vm.originMts = vm.originLot.lotWeightMts;
            applyWeightMagic();
        }

        function applyWeightMagic() {
            switch( vm.originLot.purchWtType ) {
                case 'KG':
                    //avg weights
                    vm.originWt = vm.originLot.lotWeightKgs;
                    vm.originWtGross = vm.originLot.purchLandedGrossKgs;
                    vm.originWtTare = vm.originLot.purchLandedTareKgs;
                    //manual entry
                    vm.originWtManual = vm.originLot.lotWeightKgs;
                    vm.originWtGrossManual = vm.originLot.purchLandedGrossKgs;
                    vm.originWtTareManual = vm.originLot.purchLandedTareKgs;
                    break;
                case 'LB':
                    //avg weights
                    vm.originWt = vm.originLot.lotWeightLbs;
                    vm.originWtGross = vm.originLot.purchLandedGrossLbs;
                    vm.originWtTare = vm.originLot.purchLandedTareLbs;
                    //manual entry
                    vm.originWtManual = vm.originLot.lotWeightLbs;
                    vm.originWtGrossManual = vm.originLot.purchLandedGrossLbs;
                    vm.originWtTareManual = vm.originLot.purchLandedTareLbs;
                    break;
                case 'MT':
                    //avg weights
                    vm.originWt = vm.originLot.lotWeightMts;
                    vm.originWtGross = vm.originLot.purchLandedGrossMTs;
                    vm.originWtTare = vm.originLot.purchLandedTareMTs;
                    //manual entry
                    vm.originWtManual = vm.originLot.lotWeightMts;
                    vm.originWtGrossManual = vm.originLot.purchLandedGrossMTs;
                    vm.originWtTareManual = vm.originLot.purchLandedTareMTs;
                    break;
            }
        }

        function setOriginLotWeightsQty() {
            vm.originLot.qtyBales = vm.originQty;
            vm.originLot.lotWeightKgs = vm.originKgs;
            vm.originLot.lotWeightLbs = vm.originLbs;
            vm.originLot.lotWeightMts = vm.originMts;
            //actual weights
            vm.originLot.purchNetKgs = vm.originKgs;
            vm.originLot.purchGrossKgs = vm.originKgsGross;
            vm.originLot.purchTareKgs = vm.originKgsTare;
            vm.originLot.purchNetLbs = vm.originLbs;
            vm.originLot.purchGrossLbs = vm.originLbsGross;
            vm.originLot.purchTareLbs = vm.originLbsTare;
            vm.originLot.purchNetMTs = vm.originMts;
            vm.originLot.purchGrossMTs = vm.originMtsGross;
            vm.originLot.purchTareMTs = vm.originMtsTare;
            //landed weights
            vm.originLot.purchLandedNetKgs = vm.originKgs;
            vm.originLot.purchLandedGrossKgs = vm.originKgsGross;
            vm.originLot.purchLandedTareKgs = vm.originKgsTare;
            vm.originLot.purchLandedNetLbs = vm.originLbs;
            vm.originLot.purchLandedGrossLbs = vm.originLbsGross;
            vm.originLot.purchLandedTareLbs = vm.originLbsTare;
            vm.originLot.purchLandedNetMTs = vm.originMts;
            vm.originLot.purchLandedGrossMTs = vm.originMtsGross;
            vm.originLot.purchLandedTareMTs = vm.originMtsTare;
        }

        function setOriginLotWeightsQtyManual() {
            vm.originLot.qtyBales = vm.originQty;
            switch( vm.originLot.purchWtType ) {
                case 'KG':
                    vm.originLot.lotWeightKgs = vm.originWtManual;
                    //actual weights
                    vm.originLot.purchNetKgs = vm.originWtManual;
                    vm.originLot.purchGrossKgs = vm.originWtGrossManual;
                    vm.originLot.purchTareKgs = vm.originWtTareManual;
                    //landed weights
                    vm.originLot.purchLandedNetKgs = vm.originWtManual;
                    vm.originLot.purchLandedGrossKgs = vm.originWtGrossManual;
                    vm.originLot.purchLandedTareKgs = vm.originWtTareManual;
                    break;
                case 'LB':
                    vm.originLot.lotWeightLbs = vm.originWtManual;
                    //actual weights
                    vm.originLot.purchNetLbs = vm.originWtManual;
                    vm.originLot.purchGrossLbs = vm.originWtGrossManual;
                    vm.originLot.purchTareLbs = vm.originWtTareManual;
                    //landed weights
                    vm.originLot.purchLandedNetLbs = vm.originWtManual;
                    vm.originLot.purchLandedGrossLbs = vm.originWtGrossManual;
                    vm.originLot.purchLandedTareLbs = vm.originWtTareManual;
                    break;
                case 'MT':
                    vm.originLot.lotWeightMts = vm.originWtManual;
                    //actual weights
                    vm.originLot.purchNetMTs = vm.originWtManual;
                    vm.originLot.purchGrossMTs = vm.originWtGrossManual;
                    vm.originLot.purchTareMTs = vm.originWtTareManual;
                    //landed weights
                    vm.originLot.purchLandedNetMTs = vm.originWtManual;
                    vm.originLot.purchLandedGrossMTs = vm.originWtGrossManual;
                    vm.originLot.purchLandedTareMTs = vm.originWtTareManual;
                    break;
            }
        }

        function setSplitLotWeightsManual() {
            switch( vm.splitLot.purchWtType ) {
                case 'KG':
                    vm.splitLot.lotWeightKgs = vm.splitWtManual;
                    //actual weights
                    vm.splitLot.purchNetKgs = vm.splitWtManual;
                    vm.splitLot.purchGrossKgs = vm.splitWtGrossManual;
                    vm.splitLot.purchTareKgs = vm.splitWtTareManual;
                    //landed weights
                    vm.splitLot.purchLandedNetKgs = vm.splitWtManual;
                    vm.splitLot.purchLandedGrossKgs = vm.splitWtGrossManual;
                    vm.splitLot.purchLandedTareKgs = vm.splitWtTareManual;
                    break;
                case 'LB':
                    vm.splitLot.lotWeightLbs = vm.splitWtManual;
                    //actual weights
                    vm.splitLot.purchNetLbs = vm.splitWtManual;
                    vm.splitLot.purchGrossLbs = vm.splitWtGrossManual;
                    vm.splitLot.purchTareLbs = vm.splitWtTareManual;
                    //landed weights
                    vm.splitLot.purchLandedNetLbs = vm.splitWtManual;
                    vm.splitLot.purchLandedGrossLbs = vm.splitWtGrossManual;
                    vm.splitLot.purchLandedTareLbs = vm.splitWtTareManual;
                    break;
                case 'MT':
                    vm.splitLot.lotWeightMts = vm.splitWtManual;
                    //actual weights
                    vm.splitLot.purchNetMTs = vm.splitWtManual;
                    vm.splitLot.purchGrossMTs = vm.splitWtGrossManual;
                    vm.splitLot.purchTareMTs = vm.splitWtTareManual;
                    //landed weights
                    vm.splitLot.purchLandedNetMTs = vm.splitWtManual;
                    vm.splitLot.purchLandedGrossMTs = vm.splitWtGrossManual;
                    vm.splitLot.purchLandedTareMTs = vm.splitWtTareManual;
                    break;
            }
        }

        vm.onTextClick = function( $event ) {
            $event.target.select();
        };

        function calculate() {
            if( vm.splitMethod == 'Manual Entry' ) {
                var originQty = vm.originLot.qtyBales;
                var splitQty = vm.splitLot.qtyBales;
                if( !isNaN( splitQty ) ) {
                    vm.originQty = originQty - splitQty;
                }
            } else {
                applyOriginWeightQty();
                //initialize origin weight data
                var originQty = vm.originQty;
                var originKgs = vm.originKgs;
                var originKgsGross = vm.originKgsGross;
                var originKgsTare = vm.originKgsTare;
                var originLbs = vm.originLbs;
                var originLbsGross = vm.originLbsGross;
                var originLbsTare = vm.originLbsTare;
                var originMts = vm.originMts;
                var originMtsGross = vm.originMtsGross;
                var originMtsTare = vm.originMtsTare;
                //initialize split weight data
                var splitQty = vm.splitLot.qtyBales;
                var splitKgs = 0;
                var splitKgsGross = 0;
                var splitKgsTare = 0;
                var splitLbs = 0;
                var splitLbsGross = 0;
                var splitLbsTare = 0;
                var splitMts = 0;
                var splitMtsGross = 0;
                var splitMtsTare = 0;
                //do some calculating
                if( !isNaN( splitQty ) ) {
                    vm.originQty = originQty - splitQty;
                    var originWt = Math.round( ( vm.originQty * vm.wtAvg ) * 100 ) / 100;
                    var originWtGross = Math.round( ( vm.originQty * vm.wtGrossAvg ) * 100 ) / 100;
                    var originWtTare = Math.round( ( vm.originQty * vm.wtTareAvg ) * 100 ) / 100;
                    var splitWt = Math.round( ( splitQty * vm.wtAvg ) * 100 ) / 100;
                    var splitWtGross = Math.round( ( splitQty * vm.wtGrossAvg ) * 100 ) / 100;
                    var splitWtTare = Math.round( ( splitQty * vm.wtTareAvg ) * 100 ) / 100;
                    switch( vm.originLot.purchWtType ) {
                        case 'KG':
                            //do origin weights
                            originKgs = originWt;
                            originKgsGross = originWtGross;
                            originKgsTare = originWtTare;
                            //do split weights
                            splitKgs = splitWt;
                            splitKgsGross = splitWtGross;
                            splitKgsTare = splitWtTare;
                            break;
                        case 'LB':
                            //do origin weights
                            originLbs = originWt;
                            originLbsGross = originWtGross;
                            originLbsTare = originWtTare;
                            //do split weights
                            splitLbs = splitWt;
                            splitLbsGross = splitWtGross;
                            splitLbsTare = splitWtTare;
                            break;
                        case 'MT':
                            //do origin weights
                            originMts = originWt;
                            originMtsGross = originWtGross;
                            originMtsTare = originWtTare;
                            //do split weights
                            splitMts = splitWt;
                            splitMtsGross = splitWtGross;
                            splitMtsTare = splitWtTare;
                            break;
                    }
                    vm.originWt = originWt;
                    vm.originWtGross = originWtGross;
                    vm.originWtTare = originWtTare;
                    vm.originKgs = originKgs;
                    vm.originKgsGross = originKgsGross;
                    vm.originKgsTare = originKgsTare;
                    vm.originLbs = originLbs;
                    vm.originLbsGross = originLbsGross;
                    vm.originLbsTare = originLbsTare;
                    vm.originMts = originMts;
                    vm.originMtsGross = originMtsGross;
                    vm.originMtsTare = originMtsTare;
                    vm.splitWt = splitWt;
                    vm.splitWtGross = splitWtGross;
                    vm.splitWtTare = splitWtTare;
                } else {
                    vm.splitWt = 0;
                    vm.splitWtGross = 0;
                    vm.splitWtTare = 0;
                }
                //set split Lot weight values
                vm.splitLot.qtyBales = splitQty;
                vm.splitLot.lotWeightKgs = splitKgs;
                vm.splitLot.lotWeightLbs = splitLbs;
                vm.splitLot.lotWeightMts = splitMts;
                //actual weights
                vm.splitLot.purchNetKgs = splitKgs;
                vm.splitLot.purchGrossKgs = splitKgsGross;
                vm.splitLot.purchTareKgs = splitKgsTare;
                vm.splitLot.purchNetLbs = splitLbs;
                vm.splitLot.purchGrossLbs = splitLbsGross;
                vm.splitLot.purchTareLbs = splitLbsTare;
                vm.splitLot.purchNetMTs  = splitMts;
                vm.splitLot.purchGrossMTs = splitMtsGross;
                vm.splitLot.purchTareMTs = splitMtsTare;
                //landed weights
                vm.splitLot.purchLandedNetKgs = splitKgs;
                vm.splitLot.purchLandedGrossKgs = splitKgsGross;
                vm.splitLot.purchLandedTareKgs = splitKgsTare;
                vm.splitLot.purchLandedNetLbs = splitLbs;
                vm.splitLot.purchLandedGrossLbs = splitLbsGross;
                vm.splitLot.purchLandedTareLbs = splitLbsTare;
                vm.splitLot.purchLandedNetMTs  = splitMts;
                vm.splitLot.purchLandedGrossMTs = splitMtsGross;
                vm.splitLot.purchLandedTareMTs = splitMtsTare;
            }
        }

        function resolveWtDisplay( originWt, splitWt, unit ) {
            vm.originLot.lotWeightDisplay = originWt + " " + unit;
            vm.splitLot.lotWeightDisplay = splitWt + " " + unit;
        }

        function validateSi() {
            if( vm.splitLot.purchSi !== null || vm.splitLot.purchSi !== undefined ) {
                if( vm.splitLot.lotStatus === "AVAILABLE" ) {
                    vm.splitLot.lotStatus = "ALLOCATED";
                }
                ContractCustomService.returnMinifiedSaleContractByShipment( vm.splitLot.purchSi.id ).then( function( data ) {
                    vm.splitLot.allocSale = data.data;
                    vm.splitLot.allocSi = vm.splitLot.purchSi;
                }, function( error ) {
                    resetAllocationValues();
                    console.log( JSON.stringify( error ) );
                    if( error.status !== 404 ) {
                        ToastrService.error( "Failed to fetch Sale Contract for selected Shipment: " + error.statusText, "Error");
                    }
                    console.log( error.statusText );
                });
            } else {
                resetAllocationValues();
            }
        }

        //reset sale and landed value on allocation
        function resetAllocationValues() {
            vm.splitLot.saleValue = 0;
            vm.splitLot.landedValue = 0;
            //reset sale stuff
            vm.splitLot.salePriceUnit = null;
            vm.splitLot.salePrice = 0;
            vm.splitLot.saleWtType = null;
            //remove alloc SI & sale contract
            vm.splitLot.allocSale = null;
            vm.splitLot.allocSi = null;
            //update lot status
            if( vm.splitLot.purchSi !== null && vm.splitLot.purchSi !== undefined ) {
                if( vm.splitLot.lotStatus === "AVAILABLE" ) {
                    vm.splitLot.lotStatus = "ALLOCATED";
                }
            } else {
                if( vm.splitLot.lotStatus !== "AVAILABLE" ) {
                    vm.splitLot.lotStatus = "AVAILABLE";
                }
            }
        }

    }
})();
